import React, { useRef, useEffect } from 'react';
import { array, bool, func, node, object, string } from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { ListingCard, PaginationLinks } from '../../../components';

import css from './SearchResultsPanel.module.css';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    pagination,
    search,
    setActiveListing,
    isMapVariant,
    currentUser,
    favorites,
    onToggleFavorite,
    toggleFavoriteListingId,
    paginationPageName,
    paginationPagePathParams,
    salePriceByListingId,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const page = search?.page;
  const componentRef = useRef(null);
  // useEffect(() => {
  //   if (page) {
  //     if (componentRef.current) {
  //       componentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //     }
  //   }
  // }, [listings]);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName={paginationPageName}
        pagePathParams={paginationPagePathParams}
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  const cardRenderSizes = isMapVariant => {
    if (isMapVariant) {
      // Panel width relative to the viewport
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 767px) 100vw',
        `(max-width: 1023px) ${panelMediumWidth}vw`,
        `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
        `${panelLargeWidth / 3}vw`,
      ].join(', ');
    } else {
      // Panel width relative to the viewport
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 549px) 100vw',
        '(max-width: 767px) 50vw',
        `(max-width: 1439px) 26vw`,
        `(max-width: 1920px) 18vw`,
        `14vw`,
      ].join(', ');
    }
  };

  return (
    <div className={classes} ref={componentRef}>
      <div className={isMapVariant ? css.listingCardsMapVariant : css.listingCards}>
        {listings.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={cardRenderSizes(isMapVariant)}
            setActiveListing={setActiveListing}
            showPromotedUserTag={true}
            currentUser={currentUser}
            isFavorited={favorites?.includes(l.id.uuid)}
            isFavoriteLoading={toggleFavoriteListingId === l.id.uuid}
            onToggleFavorite={onToggleFavorite}
            salePriceOverride={salePriceByListingId?.[l.id.uuid]}
            useSalePriceOverride={!!salePriceByListingId}
          />
        ))}
        {props.children}
      </div>
      {paginationLinks}
    </div>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  pagination: null,
  rootClassName: null,
  search: null,
  isMapVariant: true,
  currentUser: null,
  favorites: [],
  onToggleFavorite: null,
  toggleFavoriteListingId: null,
  paginationPageName: 'SearchPage',
  paginationPagePathParams: {},
  salePriceByListingId: null,
};

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
  isMapVariant: bool,
  currentUser: propTypes.currentUser,
  favorites: array,
  onToggleFavorite: func,
  toggleFavoriteListingId: propTypes.uuid,
  paginationPageName: string,
  paginationPagePathParams: object,
  salePriceByListingId: object,
};

export default SearchResultsPanel;
